export default {
  // ========== Títulos y etiquetas ==========
  versions: 'Versiones',
  changeState: 'Cambiar el estado del',
  modificationDate: 'Fecha de modificación',
  user: 'Usuario',
  comment: 'Comentario',
  applied: 'Aplicado',
  view: 'Vista',
  seeModification: 'Ver modificación',
  applyModification: 'Aplicar modificación',
  deleteModification: 'Eliminar modificación',
  saveComment: 'Guardar comentario',
  loading: 'Cargando...',

  // ========== Modal de copia ==========
  shouldNotExceedDuration: 'NO deben superar la duración del',
  selectElementsNotToCopy: 'Seleccione los elementos que <strong>NO</strong> desea copiar',
  copyModalInfoTitle: 'Se creará una copia del {entity} seleccionado.',
  copyModalInfoDescription: 'Por defecto se copiarán <strong>todos</strong> los elementos. Si desea <strong>excluir</strong> alguno, selecciónelo en la tabla y presione el botón de remover.',
  copyModalStep1: 'Revise los elementos a copiar',
  copyModalStep2: 'Excluya los que no desee (opcional)',
  copyModalStep3: 'Confirme la copia',
  copyModalSummaryIncluded: '{count} se copiarán',
  copyModalSummaryExcluded: '{count} excluidas',
  copyModalNoElements: 'Este {entity} no tiene {matters} ni {wrappers} asociados. Se creará una copia solo con la información base del perfil.',
  copyModalWrapperSection: 'Envoltorios a copiar',
  copyModalMatterSection: 'Asignaturas a copiar',

  // ========== Campos de tabla ==========
  creation: 'Creación',
  duration: 'Duración',
  vigencyYear: 'Año de Entrada en Vigencia',
  type: 'Tipo',

  // ========== Mensajes de éxito ==========
  commentSaved: 'Comentario guardado.',
  modificationUpdated: 'Modificación actualizada!',
  modificationDeleted: 'Modificación eliminada!',

  // ========== Mensajes de confirmación ==========
  sureToApplyModification: '¿Seguro que quiere aplicar esta modificación?',
  sureToDeleteModification: '¿Seguro que quiere eliminar esta modificación?',
  thisChangeIsIrreversible: 'Este cambio es irreversible.',

  // ========== Mensajes de éxito con contexto ==========
  requestSuccessful: 'La petición fue exitosa.',

  // ========== Mensajes de error ==========
  errorOccurredRequest: 'Ocurrió un error al realizar la petición',

  // ========== Textos de historial ==========
  revertedToModification: 'Revertido a la modificación anterior, guardada el:',

  // ========== Formulario EgressProfile ==========
  previous: 'anterior',
  intermediateOutputCode: 'Código de salida intermedia',
  intermediateOutputName: 'Nombre de salida intermedia',
  continuityCode: 'Código de continuidad',
  continuityName: 'Nombre de continuidad',
  modality: 'Modalidad',
  admissionType: 'Tipo de admisión',
  initDate: 'Fecha de inicio',
  defineInitDate: 'Definir fecha de inicio',
  intermediateOutputSemester: 'Semestre salida intermedia',
  campusesDescription: 'Se muestran las {campuses} de la {faculty}.',
  selectOneOrMultiple: 'Seleccione una o varias {entity}',
  noResults: 'No se encontró resultados para',

  // ========== Validaciones ==========
  mustSelect: 'Debe seleccionar un {entity}.',
  codeAlreadyUsed: 'El código ya está siendo utilizado.',
  cannotExceedDuration: 'No puede superar a la duración.',
  durationRange: 'Este campo debe mayor o igual a 1 y menor o igual a 40',
  enterValidYear: 'Ingrese un año válido',
  mustEnterValidInitDate: 'Debe ingresar una fecha de inicio válida.',
  mustSelectProfileType: 'Debe seleccionar un tipo de perfil.',
  mustSelectAdmissionType: 'Debe seleccionar un tipo de admisión.',

  // ========== Mensajes de confirmación modal ==========
  whenCanceling: 'Al cancelar, la duración del {entity} volverá a su estado original.',
  applyChanges: 'Aplicar cambios',
  durationOf: 'Duración del',

  // ========== RemoveEPMattersComponent ==========
  selected: 'Seleccionadas',
  selectedToNotBeCopied: 'seleccionadas para no ser copiadas:',
  remove: 'Remover',
  reassignLevel: 'Reasignar el nivel',
  to: 'a',
  listOf: 'Listado de',
  toDelete: 'a eliminar',
  thatWillNotBeCopied: 'que no se copiarán:',
  integrate: 'Integrar',
  reintegrateAll: 'Reintegrar todos',
  fromTheCopy: 'de la copia',
  select: 'Seleccionar',
  exclude: 'Excluir',
  planLevel: 'Nivel del plan',
  planLevelExceedsProfile: 'El nivel del plan de la {matter} sobrepasa al del {profile}',
  wantToRemoveSelected: '¿Desea remover las {entities} seleccionadas?',
  actionWillUnlinkObjects: 'Esta acción no se podrá revertir y se desvinculará los objetos seleccionados de este {entity}.',

  // ========== CoursesWrapperView ==========
  goTo: 'Ir al',
  of: 'de',
  initialLevel: 'Nivel inicial',
  finalLevel: 'Nivel final',
  totalPedagogicalHours: 'Horas pedagógicas totales',
  initialLevelMustNotExceed: 'El nivel inicial no debe sobrepasa al del {entity}.',
  initialLevelMustNotBeSuperiorToFinal: 'Nivel inicial no debe ser superior al nivel final',
  deletedFeminine: 'eliminada.',
  ni: 'NI',
  nf: 'NF',

  // ========== CareerForm ==========
  selectOne: 'Seleccione un',
  selectA: 'Seleccione una',
  noCreated: 'No cuenta con',
  created: 'creadas.',
  preview: 'Previsualizar',
  selectToPreview: 'para poder previsualizar.',
  noResultsFor: 'No se encontraron resultados para:',
  genericCareer: 'Carrera genérica',

  // ========== CoursesWrapperForm ==========
  mustBeGreaterThanZeroAndLessOrEqual: 'Este campo debe ser mayor que 0 y menor o igual de',
  finalLevelMustNotBeLowerThanInitial: 'Nivel final no debe ser menor al nivel inicial',
  cannotBeEmpty: 'Este campo no puede ser vacío.',
  goToCurricularDefinitionsToCreate: 'Diríjase a Definiciones Curriculares para poder crear',
  credit: 'Crédito',
  automatic: 'Automático',
  planned: 'Planificado',
  thisDoesNotHave: 'Esta {entity} no cuenta con',

  // ========== FormationLineForm ==========
  createdSuccessfully: 'Se creó exitosamente:',
}
